import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { SERVER_PATH } from "../../Requests/ParseConfiguration";
import Parse from "parse";

interface DiagnosticInfoProps {
  open: boolean;
  onClose: () => void;
}

function DiagnosticRow({ label, value }: { label: string; value: string }) {
  return (
    <TableRow>
      <TableCell sx={{ fontWeight: 600, width: 140 }}>{label}</TableCell>
      <TableCell sx={{ wordBreak: "break-all", fontFamily: "monospace" }}>
        {value || "—"}
      </TableCell>
    </TableRow>
  );
}

export default function DiagnosticInfo({ open, onClose }: DiagnosticInfoProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="h6">Diagnostic Info</Typography>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Table size="small">
          <TableBody>
            <DiagnosticRow label="Server URL" value={SERVER_PATH.SERVER_URL} />
            <DiagnosticRow label="Server Host" value={SERVER_PATH.SERVER_HOST} />
            <DiagnosticRow label="Parse Server URL" value={Parse.serverURL || "—"} />
            <DiagnosticRow label="App ID" value="quorum" />
            <DiagnosticRow label="Window Location" value={window.location.href} />
          </TableBody>
        </Table>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: "block" }}>
          Database URL is configured server-side and not exposed to the client.
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
